import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { AiOutlineHome } from 'react-icons/ai';
import { FaChevronRight } from 'react-icons/fa6';

const BreadcrumbComponents: React.FC<any> = ({ productInfo, navigate }) => {
  return (
    <>
      <div className=' bg-[#F5F5F5] py-8 px-4 hidden sm:hidden md:hidden lg:block xl:block'>
        <nav className='flex items-center text-base gap-2 mx-[16%] font-poppins'>
          <Link to='/home'>
            <AiOutlineHome className='text-black font-semibold size-6 cursor-pointer hover:text-[#4A2D1A]' />
          </Link>
          <FaChevronRight className='text-black font-semibold size-3' />
          <Link to='/products'>
            <span className='text-black text-base font-poppins'>Our Product</span>
          </Link>
          <FaChevronRight className='text-black font-semibold size-3' />
          <Link to='/products'>
            <span className='text-black text-base font-poppins'> {productInfo.item_group}</span>
          </Link>
          <FaChevronRight className='text-black font-semibold size-3' />
          <span className='text-[#4A2D1A] text-base font-poppins'> {productInfo.item_name}</span>
        </nav>
      </div>
      <div className='block sm:block md:block lg:hidden pl-3 pt-3 '>
        <button className='flex flex-row items-center text-xl gap-2' onClick={() => navigate(-1)}>
          <FaArrowLeft className='w-[16px] h-[18px]' />
          <span className='font-semibold font-rubik text-lg'>Product Details</span>
        </button>
      </div>
    </>
  );
};

export default BreadcrumbComponents;
